export const capitalizeAllWords = (string: string) => {
  if (!string.length) return string;
  return string
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
